<template>
  <div :class="['tiles-grid', { 'tiles-grid--icon': iconGrid }]">
    <div v-if="iconGrid" class="tiles-grid__icons">
      <slot />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: "BaseTilesGrid",
  props: {
    iconGrid: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.tiles-grid {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid $color-grey-100;
  border-left: 1px solid $color-grey-100;

  &--icon {
    justify-content: center;
    border: none;
  }

  &__icons {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid $color-grey-100;
    border-left: 1px solid $color-grey-100;
  }
}

@media screen and (min-width: $media-m) {
  .tiles-grid__icons {
    width: 50%;
  }
}

@media screen and (min-width: $media-l) {
  .tiles-grid__icons {
    width: auto;
    flex-wrap: nowrap;
  }
}
</style>
